import { render, staticRenderFns } from "./OtherUserTemplateEdit.vue?vue&type=template&id=70aae43c&scoped=true&lang=pug"
import script from "./OtherUserTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./OtherUserTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserTemplateEdit.vue?vue&type=style&index=0&id=70aae43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aae43c",
  null
  
)

export default component.exports